var React = require('react');

function BizwiseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.08673 0.775474L10.5685 2.51336L6.48174 17.7734L0 16.036L4.08673 0.773438V0.775474ZM14.0524 9.87437C13.0067 9.87781 12.0048 10.2951 11.2655 11.0352C10.5263 11.7753 10.1097 12.778 10.1068 13.8243C10.1101 14.8703 10.5269 15.8726 11.2661 16.6122C12.0053 17.3519 13.007 17.7689 14.0524 17.7722C15.0981 17.7693 16.1002 17.3525 16.8399 16.6128C17.5795 15.8731 17.9966 14.8707 18 13.8243C17.9971 12.7776 17.5803 11.7745 16.8406 11.0343C16.1009 10.2942 15.0985 9.87698 14.0524 9.87397V9.87437Z","fill":"#00B6B6"}));
}

BizwiseIcon.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = BizwiseIcon;

BizwiseIcon.default = BizwiseIcon;
